var map = {
	"./Dark Blue.svg": "7843",
	"./Dark Green.svg": "30a9",
	"./Dark Orange.svg": "d9a6",
	"./Dark Purple.svg": "da49",
	"./Dracula-Dark.svg": "c6f6",
	"./Dracula.svg": "a962",
	"./Light Blue.svg": "bd56",
	"./Light Green.svg": "b059",
	"./Light Orange.svg": "46075",
	"./Light Pink.svg": "f9d3",
	"./Light Purple.svg": "2df28",
	"./Magenta.svg": "7aad",
	"./Narrow Dark.svg": "be4d",
	"./Narrow.svg": "716f",
	"./Normal Dark.svg": "78a2",
	"./Normal.svg": "2597",
	"./Paper shape Dark.svg": "3fc3",
	"./Paper shape.svg": "5eb9",
	"./Paperless Dark.svg": "cb60",
	"./Paperless.svg": "bf95",
	"./Poseidon-Dark.svg": "6663",
	"./Poseidon.svg": "76a1",
	"./Wide Dark.svg": "37bc",
	"./Wide.svg": "8267"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4de9";